/**
 * AbtestService — доступ к API раздела «A/B тесты» (/api/abtest/*)
 * ====================================================================
 *
 * Спека: .claude/plans/2026-09-01-ab-test-dashboard.md
 *
 * Методика дословно повторяет `mega_ab_test.py` (см. §2 плана): числа R1/R7/R30
 * здесь НЕ совпадают с разделом «Ретеншен» — это ожидаемо, не баг.
 *
 * `/experiments` не зависит от выбора эксперимента/групп — обычный
 * `MetricsService.cachedGet`. `/compare` принимает произвольный набор групп
 * (массив `groups` уходит повторяющимися query-ключами — это уже умеет
 * `ApiService.buildQueryString`).
 */

import { MetricsService } from './metricsService';

export class AbtestService {
  /**
   * GET /api/abtest/experiments — список экспериментов за окно регистраций.
   * @param {{from?: string, to?: string}} range - границы окна регистраций (YYYY-MM-DD)
   * @param {Object} options - { signal, force }
   * @returns {Promise<Array>}
   */
  static async getExperiments({ from, to } = {}, options = {}) {
    const response = await MetricsService.cachedGet('/abtest/experiments', { from, to }, options);
    return Array.isArray(response) ? response : [];
  }

  /**
   * GET /api/abtest/compare — сравнение групп эксперимента.
   * @param {{regStart: string, regEnd: string, groups: string[], control: string,
   *   versions?: string[], horizonDays?: number, maxLevel?: number}} params
   * @param {Object} options - { signal, force }
   * @returns {Promise<Object|null>}
   */
  static async getCompare(params = {}, options = {}) {
    return MetricsService.cachedGet('/abtest/compare', params, options);
  }
}

export default AbtestService;
